import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReefRESTService } from '@reef/fwk-utils';
import { Observable } from 'rxjs';

const httpOptions = { withCredentials: true };

/**
 * Service to call REST Backend API using REEF Servers.
 */
@Injectable()
export class ReefRESTServiceImpl extends ReefRESTService {
  private readonly REEF_CONNECT_ENDPOINT = '/cn/api/v2/usap';

  constructor(private readonly httpClient: HttpClient) {
    super();
  }

  override get(serviceName: string, params?: HttpParams): Observable<any> {
    return this.httpClient.get(this.buildUrl(serviceName), { ...httpOptions, params });
  }

  override post(
    serviceName: string,
    body?: any,
    params?: HttpParams,
    headers?: HttpHeaders | { [header: string]: string | string[] }
  ): Observable<any> {
    return this.httpClient.post(this.buildUrl(serviceName), body, { ...httpOptions, params, headers });
  }

  override put(
    serviceName: string,
    body?: any,
    headers?: HttpHeaders | { [header: string]: string | string[] }
  ): Observable<any> {
    return this.httpClient.put(this.buildUrl(serviceName), body, { ...httpOptions, headers });
  }

  override delete(
    serviceName: string,
    body?: any,
    headers?: HttpHeaders | { [header: string]: string | string[] }
  ): Observable<any> {
    return this.httpClient.delete(this.buildUrl(serviceName), { ...httpOptions, body, headers });
  }

  override patch(serviceName: string, body?: any, params?: HttpParams): Observable<any> {
    return this.httpClient.patch(this.buildUrl(serviceName), body, { ...httpOptions, params });
  }

  override options(
    serviceName: string,
    headers?: HttpHeaders | { [header: string]: string | string[] }
  ): Observable<any> {
    return this.httpClient.options(this.buildUrl(serviceName), { ...httpOptions, headers });
  }

  protected buildUrl(serviceName: string) {
    const normalizedName = serviceName.startsWith('/') ? serviceName.slice(1) : serviceName;
    return `${this.REEF_CONNECT_ENDPOINT}/${normalizedName}`;
  }
}
